module.exports = __webpack_public_path__ + "static/media/siddharth-vijayawada-trip-03.d8b264d8.png";